import React, { type ComponentType } from 'react'
import * as Sentry from '@sentry/react'
import { DEPLOY_SKEW_TAG, isChunkLoadError } from './chunkLoadError'
import { newVersionStore } from './NewVersionStore'
import { NewVersionPlaceholder } from './NewVersionBanner'

/**
 * Lazily loads a component, retrying a failed chunk once before announcing a new version.
 * @param factory The dynamic import producing the component module.
 * @returns A lazy component that renders a reload prompt if its chunk stays unavailable.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyWithRetry<Component extends ComponentType<any>>(factory: () => Promise<{ default: Component }>) {
   return React.lazy(async () => {
      try {
         return await factory()
      } catch (error) {
         if (!isChunkLoadError(error)) throw error
      }

      try {
         return await factory()
      } catch (error) {
         if (!isChunkLoadError(error)) throw error
         Sentry.captureException(error, { tags: { [DEPLOY_SKEW_TAG]: 'chunk' } })
         newVersionStore.announce()
         return { default: NewVersionPlaceholder as unknown as Component }
      }
   })
}
